<template>
  <div class="banner-modify">
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <div class="form-line">
      <div class="textBox" style="margin-right: 20px;">
        <b class="red">*</b>
        <span class="line-text">标题：</span>
      </div>
      <el-input v-model="title" size="small" style="flex: 1;" />
    </div>
    <div class="form-line" style="margin: 10px 0;">
      <div class="textBox" style="margin-right: 20px;">
        <b class="red">*</b>
        <span class="line-text">类型：</span>
      </div>
      <el-select v-model="zxType" placeholder="请选择" size="mini" style="flex: 1;">
        <el-option
          v-for="item in zxTypeList"
          :key="item.code"
          :label="item.value"
          :value="item.code">
        </el-option>
      </el-select>
    </div>
    <div class="form-line" style="margin: 10px 0 0 0">
      <div class="textBox" style="margin-right: 18px;">
        <b class="red">*</b>
        <span class="line-text">banner：</span>
      </div>
      <!--<upload-img-list @getImgList="getImgList"  />-->
      <input id="uploadGuidedGraph" name="file" accept="image/*" type="file"
             @change="upData2" style="display: none" />
      <div>
        <a class="newly2" @click="upImg2" v-if="!guideMap">
          <span><i class="el-icon-plus"></i></span>
          <span>点击上传</span>
        </a>
        <a class="upload2" @click="upImg2" v-if="guideMap">
          <img :src="guideMap" id="packBg" />
          <b>重新上传</b>
        </a>
      </div>
    </div>
    <div class="form-line" style="margin: 20px 0;" v-if="zxType === '2'">
      <div class="textBox" style="margin-right: 20px;">
        <b class="red">*</b>
        <span class="line-text">链接地址：</span>
      </div>
      <el-input v-model="url" size="small" style="flex: 1;" />
    </div>
    <div class="editorBox" v-if="zxType === '1'">
      <quill-editor ref="QuillEditor"
                    class="ql-editor"
                    v-model="content"
                    :options="editorOption"
                    @blur="onEditorBlur($event)"
                    @focus="onEditorFocus($event)"
                    @ready="onEditorReady($event)">
      </quill-editor>
    </div>
    <div class="btn-line">
      <button-confirm @confirm="addActivities" value="确定" />
      <button-cancel @cancel="cancel" value="返回" />
    </div>
    <div style="width: 0px;height: 0px;" id="showImageDialogVisible" @click="chooseImageDialogVisible = true"></div>

    <el-dialog title="选择图片" :visible.sync="chooseImageDialogVisible" width="500px">
      <div>
        <upload-img-list @getImgList="getImgList" :ImgNumber="1" style="width: 140px;margin: 0 auto" v-if="chooseImageDialogVisible" />
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="chooseImageDialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="uploadImg" size="small">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import ButtonConfirm from '../../../../components/Button/ButtonConfirm'
  import ButtonCancel from '../../../../components/Button/ButtonCancel'
  import Breadcrumb from '../../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../../components/Text/TextTitle'
  import {nError, nSuccess} from '../../../../utils/notice'
  import {bus} from '../../../../utils/bus'
  import {api} from '../../../api/ConfigManagement'
  import {errorHandler} from '../../../../utils/errorHandler'
  import UploadImgList from '../../../../components/Input/UploadImgList'

  const toolbarOptions = [
    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
    ['blockquote', 'code-block'],

    [{'header': 1}, {'header': 2}],               // custom button values
    [{'list': 'ordered'}, {'list': 'bullet'}],
    [{'script': 'sub'}, {'script': 'super'}],      // superscript/subscript
    [{'indent': '-1'}, {'indent': '+1'}],          // outdent/indent
    [{'direction': 'rtl'}],                         // text direction

    [{'size': ['small', false, 'large', 'huge']}],  // custom dropdown
    [{'header': [1, 2, 3, 4, 5, 6, false]}],

    [{'color': []}, {'background': []}],          // dropdown with defaults from theme
    [{'font': []}],
    [{'align': []}],
    ['link', 'image'],
    ['clean']                                         // remove formatting button
  ]

  export default {
    components: {
      UploadImgList,
      TextTitle,
      Breadcrumb,
      ButtonCancel,
      ButtonConfirm},
    name: 'yq-zx-modify',
    data () {
      return {
        breadcrumb: [{
          value: '资源中心',
          name: 'yq-information'
        }, {
          value: 'Banner配置'
        }],
        mainTitle: '修改Banner',
        subheading: '',
        title: '',
        guideMap: '',
        pictureBase64: '',
        content: '',
        zxType: '1',
        zxTypeList: [
          {
            code: '1',
            value: '图文资讯'
          }, {
            code: '2',
            value: '微信推文链接'
          }
        ],
        editorOption: {
          modules: {
            toolbar: {
              container: toolbarOptions,  // 工具栏
              handlers: {
                'image': function (value) {
                  if (value) {
                    document.querySelector('#showImageDialogVisible').click()
                  } else {
                    this.quill.format('image', false);
                  }
                }
              }
            }
          }
        },
        responsiblePersonCode: '',
        responsiblePersonName: '',
        chooseImageDialogVisible: false,
        appId: '',
        pagePath: '',
        url: '',
        imageList: [],
        base64List: []
      }
    },
    created () {
      this.currentCode = this.$route.params.id
      this.getPartyActivityByCode()
    },
    methods: {
      getImgList (imageList, base64List) {
        this.imageList = imageList
        this.base64List = base64List
      },
      upData2: function () {
        let that = this
        const oFReader = new FileReader()
        const file = document.getElementById('uploadGuidedGraph').files[0]
        console.log(file)
        if (file.size > 1024 * 1024) {
          nError('上传图片不能大于1M')
          return false
        }
        oFReader.readAsDataURL(file)
        oFReader.onloadend = function (oFRevent) {
          const src = oFRevent.target.result
          that.pictureBase64 = src
          that.uploadPicture()
        }
      },
      upImg2: function () {
        document.getElementById('#uploadBackgroundImg')
        $('#uploadGuidedGraph')
          .click() // 隐藏了input:file样式后，点击头像就可以本地上传
          .on('change', function () {
            // const objUrl = getObjectURL(this.files[0])
            // if (objUrl) {
            //   $('#pic2').attr('src', objUrl)
            // }
          })
      },

      // 上传图片
      uploadPicture () {
        this.$axios.post(api.uploadImg, {
          picData: this.pictureBase64
        })
          .then(res => {
            if (res.data.retCode === 1) {
              this.guideMap = res.data.data
            } else {
              // 提示信息，需引入Message
              nError('图片上传失败')
            }
          })
          .catch(errorHandler('图片上传失败'))
      },
      // 上传图片
      uploadImg () {
        if (this.base64List.length < 0) {
          nError('请选择图片')
          return false
        }
        this.$axios.post(api.uploadImg, {
          picData: this.base64List[0].personImageStr
        })
          .then(res => {
            if (res.data.retCode === 1) {
              // this.content += `<img src="${res.data.data}">`
              // console.log(this.content)
              let quill = this.$refs.QuillEditor.quill

              let length = quill.selection.savedRange.index

              quill.insertEmbed(length, 'image', res.data.data)

              quill.setSelection(length + 1)
              this.chooseImageDialogVisible = false
              this.imageList = []
              this.base64List = []
            } else {
              // 提示信息，需引入Message
              nError('图片插入失败')
            }
          })
          .catch(errorHandler('图片插入失败'))
      },
      getPartyActivityByCode () {
        this.$axios.get(`${api.getAppletBannerByCode}/${this.currentCode}`, {})
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              this.title = data.title
              this.source = data.source
              this.guideMap = data.guideMap
              this.content = decodeURI(data.content)
              this.url = data.url
              // this.pagePath = data.pagePath
              if (data.url) {
                this.zxType = '2'
              } else {
                this.zxType = '1'
              }
              this.responsiblePersonCode = data.responsiblePersonCode
              this.responsiblePersonName = data.responsiblePersonNam
            }
          })
          .catch(errorHandler('查询失败'))
      },
      onEditorBlur(editor) {},
      onEditorFocus(editor) {},
      onEditorReady(editor) {},
      onEditorChange({ editor, html, text }) {
        // console.log('editor change!', editor, html, text)
        this.content = html
      },

      // 添加
      addActivities () {
        if (!this.title) {
          nError('请输入标题')
          return false
        }
        if (!this.guideMap) {
          nError('请选择banner图片')
          return false
        }
        let reqData = {
          code: this.currentCode,
          title: this.title,
          guideMap: this.guideMap,
          content: '',
          appId: '',
          pagePath: '',
          responsiblePersonCode: this.responsiblePersonCode,
          responsiblePersonName: this.responsiblePersonName
        }
        if (this.zxType === '1') {
          if (!this.content) {
            nError('请输入内容')
            return false
          }
          reqData.content = encodeURI(this.content)
          reqData.url = ''
        } else {
          if (this.url.indexOf('https://mp.weixin.qq.com') === -1) {
            nError('请输入微信推文链接')
            return false
          }
          reqData.content = ''
          reqData.url = this.url
        }
        this.$axios.post(api.updateAppletBanner, reqData)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('修改成功')
              this.cancel()
            }
          })
          .catch(errorHandler('修改失败'))
      },

      // 取消
      cancel () {
        this.$router.push({
          name: 'banner-manage'
        })
      }
    },
  }
</script>

<style lang="less">
  .red {
    color: #FF0000;
    vertical-align: sub;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .banner-modify {
    padding: 20px;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    //.editorBox {
    //  padding: 20px 0;
    //  width: 100%;
    //  height: auto;
    //  margin-bottom: 20px;
    //  min-height: 200px;
    //  max-height: 720px;
    //  overflow-y: auto;
    //}
    .ql-snow {
      .ql-tooltip {
        left: 0!important;
        right: 0!important;
        margin: 0 auto!important;
      }
    }
    .btn-line {
      width: 300px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/ResourceCenter/configManagement/BannerConfig/BannerModify.vue